import Autocomplete from "../../autocomplete";
import { Item } from "../interfaces";
import { GetBemBlocksWith } from "../../utils";
import { getOrCreateFragments } from "./helpers";

export interface TermProps {
  item: Item;
  getBEMBlocksWith: GetBemBlocksWith;
  shouldHighlightItems: boolean;
}

const ItemTerm = (props: TermProps) => {
  const { item, getBEMBlocksWith, shouldHighlightItems } = props;

  const { inputValue } = Autocomplete.useContext();
  if (shouldHighlightItems) {
    const fragments = getOrCreateFragments(item, inputValue);

    return (
      <>
        {fragments.map((fragment, fragmentIndex) =>
          fragment.isHighlighted ? (
            <mark
              className={getBEMBlocksWith("__mark")}
              key={`${fragment.text}-${fragmentIndex}`}
            >
              {fragment.text}
            </mark>
          ) : (
            fragment.text
          ),
        )}
      </>
    );
  }

  return <>{item.term}</>;
};

ItemTerm.displayName = "ItemTerm";

export default ItemTerm;
